import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JgVisualInspUnitFb } from '../models/jg/jg-visual-insp-unit-fb.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class JgVisualInspUnitFbService extends RequestService<JgVisualInspUnitFb> {
  static PATH = '/jg/visualInsp/unitFb';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(httpClient, JgVisualInspUnitFbService.PATH, globalService.debugUrl);
  }
}
